import { COOKIES } from '@bulknutrients/bulk-shared-lib/constants';
import { BulkErrorBoundary } from '@components/Alerts/ErrorBoundaryFallback';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { Container } from '@components/Container';
import { Footer } from '@components/Footer';
import { Header } from '@components/Header/Header';
import { useIsTabActive } from '@hooks/useIsTabActive';
import Cookies from 'js-cookie';
import { type FC, type ReactNode, useEffect, useState } from 'react';

type Props = {
  children: ReactNode;
  additionalCrumbs?: { title: string; path: string }[];
};

const AccountLayout: FC<Props> = ({ children, additionalCrumbs }) => {
  const tabInFocus = useIsTabActive();
  const [customerToken, setCustomerToken] = useState<string | null>(null);

  // Handle logout between tabs
  // Read the customer cookie into state whenever the tab becomes active
  useEffect(() => {
    if (tabInFocus) {
      const cookie = Cookies.get(COOKIES.customer);

      if (cookie && customerToken === null) {
        setCustomerToken(cookie); // Set the cookie in state
      } else if (cookie && cookie !== customerToken) {
        window.location.reload(); // customer has changed
      }
    }
  }, [tabInFocus]);

  return (
    <>
      <Header />

      <BulkErrorBoundary location="Account Layout">
        <Container id="account-breadcrumbs">
          <Breadcrumbs
            crumbs={[
              { title: 'home', path: '/' },
              { title: 'My Account', path: '/account/home' },
              ...(additionalCrumbs || []),
            ]}
          />
        </Container>
        <Container
          as="main"
          id="main-content"
          className="grid-cols-[1fr_min(var(--width-narrow-page),calc(100%-16px))_1fr]"
        >
          {children}
        </Container>
      </BulkErrorBoundary>

      <Footer />
    </>
  );
};

export { AccountLayout };
